import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "@src/appV2/FeatureFlags/constants";

export function useWorkerEtaImprovementsConfig() {
  return useCbhFlag(CbhFeatureFlag.WORKER_ETA_IMPROVEMENTS, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.WORKER_ETA_IMPROVEMENTS],
  });
}
